import { render, staticRenderFns } from "./authPhoneStyle.vue?vue&type=template&id=40f49e22&scoped=true"
import script from "./authPhoneStyle.vue?vue&type=script&lang=js"
export * from "./authPhoneStyle.vue?vue&type=script&lang=js"
import style0 from "./authPhoneStyle.vue?vue&type=style&index=0&id=40f49e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f49e22",
  null
  
)

export default component.exports